import { createCRUDHook } from './createCRUDHook';
import { StoreSectionDto } from 'utils/models';
import { ECG_STORE_SECTION } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<StoreSectionDto>({
  entityName: 'StoreSection',
  endpoint: ECG_STORE_SECTION,
});

export const StoreSectionContext = Context;
export const useStoreSectionManager = useManager;
export const useStoreSection = useConsumer;
